// CONSOLIDAÇÃO DE ALTERNATIVAS
export const ON_CREATE_CONSOLIDATIONS = 'ON_CREATE_CONSOLIDATIONS';
export const ON_DELETE_CONSOLIDATIONS = 'ON_DELETE_CONSOLIDATIONS';
export const ON_EDIT_CONSOLIDATIONS = 'ON_EDIT_CONSOLIDATIONS';
export const ON_CLEAR_SELECTIONS = 'ON_CLEAR_SELECTIONS';

// GERENCIADOR DE TEMAS E FONTES DE GRÁFICOS
export const ON_SIMPLE_CHART_COLOR_CHANGE = 'ON_SIMPLE_CHART_COLOR_CHANGE';

// FLUXO GRÁFICO DE CRUZAMENTO SIMPLES
export const ON_OPEN_SIMPLE_CROSS_CONFIG = 'ON_OPEN_SIMPLE_CROSS_CONFIG';
export const ON_SIMPLECROSS_CONFIG_CHANGE = 'ON_SIMPLECROSS_CONFIG_CHANGE';

// EVOLUTIVO DE CRUZAMENTOS
export const ON_CHANGE_SURVEYLIST_SELECTED_ITEMS = 'ON_CHANGE_SURVEYLIST_SELECTED_ITEMS';
export const ON_UPDATE_SURVEYLIST_SELECTED_ITEMS = 'ON_UPDATE_SURVEYLIST_SELECTED_ITEMS';

export const ON_CHANGE_EVOLUTIVE_CROSS_BUTTON_STATE = 'ON_CHANGE_EVOLUTIVE_CROSS_BUTTON_STATE';
export const ON_CHANGE_QUESTIONLIST_SELECTED_ITEMS = 'ON_CHANGE_QUESTIONLIST_SELECTED_ITEMS';

export const ON_UPDATE_QUESTIONLIST_SELECTED_ITEMS = 'ON_UPDATE_QUESTIONLIST_SELECTED_ITEMS';
export const ON_COMBINE_QUESTIONS = 'ON_COMBINE_QUESTIONS';
export const ON_COMBINE_ALTERNATIVES = 'ON_COMBINE_ALTERNATIVES';
export const ON_EDIT_COMBINED_ALTERNATIVES = 'ON_EDIT_COMBINED_ALTERNATIVES';
export const ON_UPDATE_GROUP_QUESTIONS = 'ON_UPDATE_GROUP_QUESTIONS';
export const ON_EDIT_GROUP_QUESTIONS = 'ON_EDIT_GROUP_QUESTIONS';
export const ON_CLEAR_QUESTIONS_AFTER_COMBINE = 'ON_CLEAR_QUESTIONS_AFTER_COMBINE';
export const ON_EDIT_COMBINED_QUESTIONS = 'ON_EDIT_COMBINED_QUESTIONS';
export const ON_OPEN_SEND_COMBINATION_MODAL = 'ON_OPEN_SEND_COMBINATION_MODAL';
export const ON_RENDER_EVOLUTIVE_CROSS_FOOTER_OPTIONS = 'ON_RENDER_EVOLUTIVE_CROSS_FOOTER_OPTIONS';
export const ON_CHANGE_SEND_COMBINATION_VISIBILITY = 'ON_CHANGE_SEND_COMBINATION_VISIBILITY';

export const ON_CHANGE_STEP_THREE_INTERNAL_DATA = 'ON_CHANGE_STEP_THREE_INTERNAL_DATA';

export const ON_UPDATE_STEP_ONE_DATA = 'UPDATE_STEP_ONE_DATA';
export const ON_UPDATE_STEP_TWO_DATA = 'UPDATE_STEP_TWO_DATA';
export const ON_UPDATE_STEP_THREE_DATA = 'UPDATE_STEP_THREE_DATA';
export const ON_OPEN_SEND_ALTERNATIVE_MODAL = 'ON_OPEN_SEND_ALTERNATIVE_MODAL';